
import getSummaries from '@/utils/mixins/transaction-get-summaries.js';
export default {
  mixins: [getSummaries],
  props: {
    previewContract: {
      type: Object,
      default: {}
    },
    massifType: {
      type: Array,
      default: []
    },
    closeBtn: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      citytitle: ''
    };
  },
  computed: {
    previewPageContract () {
      if (this.previewContract) {
        return JSON.parse(this.previewContract.assetsInfo);
      }
    }
  },
  created () {
  },
  mounted () {
    setTimeout(() => {
      console.log(this.previewPageContract, 'previewPageContract');
    }, 500);
  },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600) {
        this.$emit('enabledBtn');
      }
    },
    dialogFormClick () {
      this.$emit('dialogFormClick');
    }
  }
};
